/**
 * In-memory token storage for jury authentication
 * Stores access token in memory only (not localStorage) for better security
 * Prevents XSS attacks from stealing the access token
 */

let accessToken = null;

export const tokenStorage = {
    getAccessToken: () => accessToken,

    setAccessToken: (token) => {
        accessToken = token;
        tokenStorage.onChange();
    },

    clearAccessToken: () => {
        accessToken = null;
        tokenStorage.onChange();
    },

    hasAccessToken: () => accessToken !== null,

    onChange: () => {},
};
